import axiosInstance from 'api/axios'
import {
  BaseRegisterRequest,
  ECareLevel,
  EUserEducation,
  EUserExperience,
  RegisterRequest,
  SubscribeResponse,
  SubscriptionPlanType,
  UserType,
} from 'types'
import { FamilyFormType, normalizePartnerCode } from '../components/AuthSignupFamily/types'
import { TraineeFormType } from '../components/AuthSignupTrainee/types'

export const createPaymentIntent = (
  email: string,
  paymentMethodId: string,
  subscriptionKind: 'trainee' | 'caregiver',
  formData: FamilyFormType | TraineeFormType,
  plan: SubscriptionPlanType | null,
  /** Unfunded partner code entered on its own step — sent for partner attribution only. */
  partnerCode?: string,
): Promise<{ data: SubscribeResponse }> => {
  let registerRequest: RegisterRequest | null
  const base: BaseRegisterRequest = {
    accessCode: null,
    firstname: formData.firstName,
    lastname: formData.lastName,
    email: formData.email,
    type: subscriptionKind === 'trainee' ? UserType.TRAINEE : UserType.CAREGIVER,
    password: formData.myNewPassword,
  }

  if ('education' in formData) {
    registerRequest = {
      ...base,
      education: formData.education as EUserEducation,
      experience: formData.yearsOfExperience as EUserExperience,
      language: formData.language === 'other' ? formData.languageOther : formData.language,
    }
  } else {
    registerRequest = {
      ...base,
      personOfConcernFirstName: formData.personOfConcernFirstName,
      personOfConcernLastName: formData.personOfConcernLastNameOrInitial,
      careLevel: formData.levelOfCareNeeded as ECareLevel,
      partnerCode: normalizePartnerCode(partnerCode),
    }
  }

  return axiosInstance.post('/auth/subscribe', {
    email,
    paymentMethodId,
    subscriptionKind,
    plan,
    userData: registerRequest,
  })
}

export const createPaymentIntentInvited = (
  invitationToken: string,
  firstname: string,
  lastname: string,
  password: string,
  paymentMethodId: string,
  plan: SubscriptionPlanType,
  /** Required for phone-only invites: the JWT carries no email, so the backend takes it from the body. */
  email: string,
  partnerCode?: string,
): Promise<{ data: SubscribeResponse }> => {
  return axiosInstance.post('/auth/subscribe-invited', {
    invitationToken,
    firstname,
    lastname,
    password,
    paymentMethodId,
    plan,
    email,
    partnerCode,
  })
}
